import { createTagCloudController } from '../../external/tag-cloud-widget/controller';

export default createTagCloudController;
